import * as React from 'react';
import { Box, Typography, Grid, Card, CardContent, Chip } from '@mui/material';
import InformationalLayout from './InformationalLayout';

function Integrations() {
    const integrations = [
        {
            name: 'Ride With GPS',
            status: 'active',
            logo: 'https://ridewithgps.com/images/revised_layout/logo.png',
            description: 'Import routes directly from your Ride With GPS account. Create cue cards from your saved routes.'
        },
        {
            name: 'Strava',
            status: 'active',
            logo: "https://developers.strava.com/images/strava_logo_nav.png",
            description: 'Connect your Strava account to import routes. Create cue cards from your saved routes.'
        },
        {
            name: 'GPX Files',
            status: 'coming-soon',
            logo: null,
            description: 'Upload GPX files from any device or platform. Works with Garmin, Wahoo, and other GPS devices.'
        },
        {
            name: 'Komoot',
            status: 'coming-soon',
            logo: null,
            description: 'Import routes from your Komoot account. Create cue cards from your planned tours and favorite routes.'
        },
        {
            name: 'Garmin',
            status: 'coming-soon',
            logo: null,
            description: 'Direct integration with Garmin Connect coming soon. Import routes to create cue cards.'
        }
    ];

    return (
        <InformationalLayout
            title="Integrations"
            subtitle="Connect CueMeUp with your favorite platforms and devices to create seamless cue cards for all your adventures and stay in sync with your latest routes and activities."
        >

            {/* Integration Cards */}
            <Grid container spacing={4}>
                {integrations.map((integration, index) => (
                    <Grid item xs={12} md={6} key={index}>
                        <Card sx={{
                            height: '100%',
                            backgroundColor: 'rgba(255,255,255,0.95)',
                            transition: 'transform 0.2s ease-in-out',
                            '&:hover': {
                                transform: 'translateY(-4px)',
                                boxShadow: 6
                            }
                        }}>
                            <CardContent sx={{ p: 4 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    {integration.logo ? (
                                        <img
                                            src={integration.logo}
                                            alt={`${integration.name} Logo`}
                                            style={{ height: 24, marginRight: 8 }}
                                        />
                                    ) : (
                                        <Box sx={{ width: 24, height: 24, mr: 1, backgroundColor: '#666', borderRadius: 1 }} />
                                    )}
                                    <Box sx={{ flex: 1 }}>
                                        <Typography variant="h5" sx={{ fontWeight: 600, color: '#2c3e50' }}>
                                            {integration.name}
                                        </Typography>
                                        <Chip
                                            label={integration.status === 'active' ? 'Available' : 'Coming Soon'}
                                            color={integration.status === 'active' ? 'success' : 'default'}
                                            size="small"
                                            sx={{ mt: 1 }}
                                        />
                                    </Box>
                                </Box>

                                <Typography variant="body1" sx={{ color: '#6c757d' }}>
                                    {integration.description}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

        </InformationalLayout>
    );
}

export default Integrations;
